<template>
  <div class="wrap">
    <iframe src="http://www.hightopo.com/demo/qiandaogui/" frameborder="0" height='100%'></iframe>
  </div>
</template>

<script>
export default {
  name: 'model',
  data(){
    return{
      options:''
    }
  },
  mounted() {
    this.getManiceList()
  },
  methods:{
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.options = res.data.options
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    }
  }
}
</script>

<style scoped>
  .wrap{
    width: 100%;
    height: 100%;
  }
  iframe{
    width: 100%;
    height: 100%;
  }
</style>
